import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
    ) { }

  ngOnInit() {
    this.titleService.setTitle('关于Trinka-英语学术和技术写作工具');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka是学术和技术英语写作的更好工具。 我们的目标是消除语言和写作技能在有效知识沟通上形成的障碍。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '用于学术和技术写作的语法检查工具，学术写作助手，技术写作助手，高级语法检查，自动语法检查工具' });
    this.metaTagService.updateTag({ property: 'og:title', content: '关于Trinka-英语学术和技术写作工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka是学术和技术英语写作的更好工具。 我们的目标是消除语言和写作技能在有效知识沟通上形成的障碍。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn/aboutus' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-cn' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/aboutus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/aboutus' });
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../assets/js/about_us_testimonial_silders.js', function () { });
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
  }
  ngAfterViewInit(){
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/branding_logo.js', function () { });
    }
  }

}